import { render, staticRenderFns } from "./FullImageModal.vue?vue&type=template&id=0f7c5f47&"
import script from "./FullImageModal.vue?vue&type=script&lang=js&"
export * from "./FullImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports